// A soft, airy breath made in the browser: it swells on "breathe in", rests on "hold", fades on "release".
let ctx = null, gain = null, filter = null;

function ensure() {
  if (ctx || typeof window === "undefined") return;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return;
  ctx = new AC();
  const len = ctx.sampleRate * 2;
  const buf = ctx.createBuffer(1, len, ctx.sampleRate);
  const d = buf.getChannelData(0);
  let last = 0;
  for (let i = 0; i < len; i++) { last = (last + 0.02 * (Math.random() * 2 - 1)) / 1.02; d[i] = last * 3.5; }
  const src = ctx.createBufferSource(); src.buffer = buf; src.loop = true;
  filter = ctx.createBiquadFilter(); filter.type = "bandpass"; filter.frequency.value = 500; filter.Q.value = 0.7;
  gain = ctx.createGain(); gain.gain.value = 0;
  src.connect(filter).connect(gain).connect(ctx.destination);
  src.start();
}

export function primeBreath() {
  ensure();
  if (ctx && ctx.state === "suspended") ctx.resume().catch(() => {});
}

export function breathe(phase) {
  ensure();
  if (!ctx) return;
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  const now = ctx.currentTime, g = gain.gain, f = filter.frequency;
  g.cancelScheduledValues(now); f.cancelScheduledValues(now);
  g.setValueAtTime(g.value, now); f.setValueAtTime(f.value, now);
  if (phase === "in") {
    g.linearRampToValueAtTime(0, now + 1); f.setValueAtTime(450, now + 1);
    g.linearRampToValueAtTime(0.09, now + 4.4); f.linearRampToValueAtTime(1100, now + 4.4);
    g.linearRampToValueAtTime(0.015, now + 5);
  } else if (phase === "out") {
    g.linearRampToValueAtTime(0, now + 1); f.setValueAtTime(900, now + 1);
    g.linearRampToValueAtTime(0.08, now + 1.6);
    g.linearRampToValueAtTime(0, now + 5.6); f.linearRampToValueAtTime(300, now + 5.6);
  } else {
    g.linearRampToValueAtTime(0, now + 0.8);
  }
}

export function breathStop() { if (ctx) breathe("rest"); }
